import React from 'react';
import { PaymentForm } from '../PaymentForm';
import { MopDisplayContent } from '../MopDisplayContent';
import { useDispatch } from 'react-redux';
import { PaddedContainer, Divider, CardViewWrapper } from './styled';
import { setModeClickHandler } from '../DefaultMopView/helpers';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { AppMode } from '../../redux/AppModeState/AppModeState.types';
import { LinkWithDisabledStyle, AddPaymentMethodLinkWrapper } from '../PaymentForm/styled';
import { getString } from '../../constants/Strings';
import { useAppSelector } from '../../hooks/useAppSelector';
import { appModeSelector } from '../../redux/AppModeState/AppModeState.selectors';
import { mopOnFileSelector } from '../../redux/MopOnFileState/MopOnFileState.selectors';
import { resetForm } from '../../redux/PaymentState/helpers/resetForm';
import { getPaymentFieldLabelText } from '../PaymentForm/helpers';
import { paymenFormSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { PaymentFormDataFields } from '../UserAddress/constants';
var CardFormView = function CardFormView(props) {
  var appMode = useAppSelector(appModeSelector);
  var mopOnFile = useAppSelector(mopOnFileSelector);
  var paymentForm = useAppSelector(paymenFormSelector);
  var selectedMop = mopOnFile.selectedMop;
  var goBackMode = appMode.goBackMode;
  var dispatch = useDispatch();
  var clientInstance = props.clientInstance,
    hostedFieldsService = props.hostedFieldsService,
    isEdit = props.isEdit,
    isHidden = props.isHidden,
    optimizelyClient = props.optimizelyClient;
  var isInitializing = !!(hostedFieldsService !== null && hostedFieldsService !== void 0 && hostedFieldsService.getIsInitializing());
  var onAddPaymentMethodHandler = function onAddPaymentMethodHandler(e) {
    e.preventDefault();
    if (isInitializing) return; // do not allow user to exit when hosted fields is initializing to prevent tear down after teardown error
    /* If a user in add mode cancels, they will want to go back to this view's goBackMode, not back to the edit view. */
    setModeClickHandler(AppMode.ADD, goBackMode, dispatch);
    hostedFieldsService && resetForm(hostedFieldsService, dispatch);
  };
  return /*#__PURE__*/React.createElement(CardViewWrapper, {
    isHidden: isHidden,
    "data-test": DataTestAttributes.CARD_VIEW_CONTAINER
  }, isEdit && /*#__PURE__*/React.createElement(PaddedContainer, {
    "data-test": DataTestAttributes.MOP_DISPLAY_CONTAINER
  }, /*#__PURE__*/React.createElement(MopDisplayContent, {
    mop: selectedMop
  })), /*#__PURE__*/React.createElement(PaymentForm, {
    clientInstance: clientInstance,
    hostedFieldsService: hostedFieldsService,
    isEdit: isEdit,
    optimizelyClient: optimizelyClient
  }), isEdit && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(AddPaymentMethodLinkWrapper, null, /*#__PURE__*/React.createElement(LinkWithDisabledStyle, {
    "data-test": DataTestAttributes.ADD_PAYMENT_METHOD_LINK,
    hasButtonBehavior: true,
    href: isInitializing ? '' : '#',
    onClick: onAddPaymentMethodHandler,
    role: 'button',
    disabled: isInitializing,
    "aria-disabled": isInitializing,
    className: 'card-form-view-add-pm-link'
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.ADD_PAYMENT_METHOD) || getString('APP.MOPONFILE.ADD.PAYMENT.METHOD')))));
};
export default CardFormView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/CardFormView/index.js
// module id = 4538
// module chunks = 11